import LanguagesList from './LanguagesList'

export default LanguagesList
